export enum BtnTheme {
  DEFAULT = 'btn-default',
  PRIMARY = 'btn-primary',
  SECONDARY = 'btn-secondary',
  SUCCESS = 'btn-success',
  WARNING = 'btn-warning',
  DANGER = 'btn-danger',
  CRITICAL = 'btn-critical'
}
